import React from "react";
import { Route } from "react-router-dom";
import PublicLayout from "../layouts/public/index";

const PublicContent = ({ component: C, props: cProps, ...rest }) => {
    return <Route
        {...rest}
        render={props=> <PublicLayout  {...props} {...cProps} component={(props) => <C  {...cProps} {...props} />} />} />
}

export default PublicContent;